import { RiAttachment2 } from "react-icons/ri";
import React, { useRef, ChangeEvent } from "react";

import IconButton from "@Components/IconButton";

interface FileInputButtonProps {
  onChange: (file: File) => void;
}

const FileInputButton: React.FC<FileInputButtonProps> = ({ onChange }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onChange(file);
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <IconButton onClick={handleButtonClick}>
        <RiAttachment2 size={35} fill="#6b97f6" />
      </IconButton>
    </div>
  );
};

export default FileInputButton;
